export default __webpack_public_path__ + "static/media/mastery-bar-cap.39177af1.png";